import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { VersionModal } from './common';
import FloatingTool from './FloatingTool';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [versionVisible, setVersionVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // 监听窗口大小变化
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 移动端默认收起侧边栏
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [isMobile]);

  // 点击导航项后收起侧边栏（移动端）
  const handleNavClick = () => {
    if (isMobile) {
      setCollapsed(true);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const getMenuItems = () => {
    const items = [];

    if (user.role === 'admin') {
      items.push(
        { path: '/admin/dashboard', label: '仪表盘' },
        { path: '/admin/users', label: '用户管理' },
        { path: '/admin/accounts', label: '账号管理' },
        { path: '/admin/sales', label: '销售记录' },
        { path: '/admin/cost-management', label: '成本管理' },
        { path: '/admin/emails', label: '邮件记录' },
        { path: '/admin/logs', label: '操作日志' }
      );
    } else if (user.role === 'developer') {
      items.push(
        { path: '/developer/dashboard', label: '仪表盘' },
        { path: '/developer/accounts', label: '我的账号' },
        { path: '/developer/sales', label: '关联销售' },
        { path: '/developer/emails', label: '邮件记录' }
      );
    } else if (user.role === 'sales') {
      items.push(
        { path: '/sales/dashboard', label: '仪表盘' },
        { path: '/sales/records', label: '销售记录' },
        { path: '/sales/emails', label: '邮件记录' }
      );
    }

    // 所有角色都可见
    items.push({ path: '/documents', label: '文档中心' });

    return items;
  };

  const roleLabels = {
    admin: '管理员',
    developer: '开发者',
    sales: '销售'
  };

  // 计算侧边栏类名：移动端使用 open/closed，桌面端使用 collapsed
  const getSidebarClassName = () => {
    if (isMobile) {
      return `sidebar ${collapsed ? '' : 'open'}`;
    }
    return `sidebar ${collapsed ? 'collapsed' : ''}`;
  };

  return (
    <div className="layout">
      {/* 移动端遮罩层 */}
      {isMobile && !collapsed && (
        <div
          className="sidebar-overlay visible"
          onClick={() => setCollapsed(true)}
        />
      )}
      <aside className={getSidebarClassName()}>
        <div className="sidebar-header">
          <h2>账号管理系统</h2>
        </div>
        <nav className="sidebar-nav">
          {getMenuItems().map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              title={collapsed ? item.label : ''}
              onClick={handleNavClick}
            >
              <span className="nav-text">{item.label}</span>
            </Link>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-name">{user.real_name || user.username}</span>
            <span className="user-role">{roleLabels[user.role]}</span>
          </div>
          <Link to="/profile" className="nav-item" onClick={handleNavClick}>个人中心</Link>
          <button className="nav-item" style={{ background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', width: '100%', fontSize: '14px', color: '#ecf0f1' }} onClick={() => setVersionVisible(true)}>
            版本信息
          </button>
          <button onClick={handleLogout} className="logout-btn">退出登录</button>
        </div>
      </aside>
      <main className={`main-content ${collapsed ? 'expanded' : ''}`}>
        <button
          className="sidebar-toggle-btn"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? "展开菜单" : "收起菜单"}
        >
          {collapsed ? '☰' : '✕'}
        </button>
        {children}
      </main>
      <VersionModal visible={versionVisible} onClose={() => setVersionVisible(false)} />
      <FloatingTool />
    </div>
  );
};

export default Layout;
